import Constants from 'app/shared/constants';

const ModalActions = {
    showModal(payload) {
        return {
            type: Constants.MODAL_SHOW,
            payload,
        };
    },
    updateModal(payload) {
        return {
            type: Constants.MODAL_UPDATE,
            payload,
        };
    },
    hideModal() {
        return {
            type: Constants.MODAL_HIDE,
        };
    },
    updateShouldReloadOnLoginSuccess(payload) {
        return {
            type: Constants.SHOULD_RELOAD_ON_LOGIN_SUCCESS,
            payload,
        };
    },

    // TODO: clean up
    updateDisplayAddPropertyModal(payload) {
        return dispatch => dispatch({
            type: Constants.MODAL_ADD_PROPERTY_UPDATE_DISPLAY,
            payload,
        });
    },
    updateDisplayImageCarouselModal(payload) {
        return dispatch => dispatch({
            type: Constants.MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY,
            payload,
        });
    },
};

export default ModalActions;
